import { render, staticRenderFns } from "./StripsList.vue?vue&type=template&id=5d129f2a&"
import script from "./StripsList.vue?vue&type=script&lang=js&"
export * from "./StripsList.vue?vue&type=script&lang=js&"
import style0 from "./StripsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports